import { AjaxService } from './Ajax.service';

/**
 * ApiBase is the base class of all connected services
 * The parent is the singleton Ajax service
 */
export default class ApiBase {
  constructor(protected api: AjaxService) {
  }
}
